import { gql } from "@apollo/client";

const BOARD_CONFIG_FIELDS = gql`
  fragment BoardConfigFields on BoardConfig {
    _id
    name
    prefix
    currentCounter
    description
    statuses { name order color isCompletion }
    roadmapOptions
    priorities { name color }
    fieldConfig {
      impact { enabled label scale { value label } }
      effort { enabled label scale { value label } }
      attachments { enabled }
      uploadLinks { enabled }
      linkedUsers { enabled }
      linkedEntities { enabled }
      linkedOpportunities { enabled }
      linkedAssets { enabled }
      linkedTransactions { enabled }
      linkedProducts { enabled }
      copyBranchName { enabled }
    }
    customFields { id name type options scale { value label } required order placeholder description }
    tableColumns { id source label width visible order }
    boardMembers { _id firstName lastName email }
    subscribers { _id }
    teams
    isActive
    createdAt
    updatedAt
  }
`;

export const GET_BOARD_CONFIGS = gql`
  ${BOARD_CONFIG_FIELDS}
  query GetBoardConfigs($isActive: Boolean) {
    boardConfigs(isActive: $isActive) { ...BoardConfigFields }
  }
`;

export const GET_BOARD_CONFIG = gql`
  ${BOARD_CONFIG_FIELDS}
  query GetBoardConfig($identifier: String!) {
    boardConfig(identifier: $identifier) { ...BoardConfigFields }
  }
`;

export const CREATE_BOARD_CONFIG = gql`
  ${BOARD_CONFIG_FIELDS}
  mutation CreateBoardConfig($input: CreateBoardConfigInput!) {
    createBoardConfig(input: $input) { ...BoardConfigFields }
  }
`;

export const UPDATE_BOARD_CONFIG = gql`
  ${BOARD_CONFIG_FIELDS}
  mutation UpdateBoardConfig($boardId: ID!, $updates: UpdateBoardConfigInput!, $pendingChanges: PendingChangesInput) {
    updateBoardConfig(boardId: $boardId, updates: $updates, pendingChanges: $pendingChanges) { ...BoardConfigFields }
  }
`;

export const DELETE_BOARD_CONFIG = gql`
  mutation DeleteBoardConfig($boardId: ID!) {
    deleteBoardConfig(boardId: $boardId) { _id name }
  }
`;

export const SEED_DEFAULT_BOARDS = gql`
  mutation SeedDefaultBoards {
    seedDefaultBoards { _id name prefix }
  }
`;

export const SUBSCRIBE_TO_BOARD = gql`
  mutation SubscribeToBoard($boardId: ID!) {
    subscribeToBoard(boardId: $boardId) {
      _id
      subscribers { _id }
    }
  }
`;

export const UNSUBSCRIBE_TO_BOARD = gql`
  mutation UnsubscribeToBoard($boardId: ID!) {
    unsubscribeToBoard(boardId: $boardId) {
      _id
      subscribers { _id }
    }
  }
`;

export const GET_BOARD_FIELD_USAGE = gql`
  query GetBoardFieldUsage($boardId: ID!) {
    boardFieldUsage(boardId: $boardId) {
      statuses { name taskCount scheduleCount }
      roadmapOptions { name taskCount scheduleCount }
      priorities { name taskCount scheduleCount }
      customFields {
        id
        taskCount
        scheduleCount
        options { value taskCount scheduleCount }
      }
      impact { value taskCount scheduleCount }
      effort { value taskCount scheduleCount }
    }
  }
`;

export const GET_BOARD_MEMBERS = gql`
  query GetBoardMembers($identifier: String!) {
    boardConfig(identifier: $identifier) {
      _id
      boardMembers { _id firstName lastName email }
    }
  }
`;
